import React from 'react'

import clsx from 'clsx'

import Screenshots from 'components/Screenshots'
import { useListingDetailContext } from 'context/ListingDetailContext'

import classes from './Slider.module.scss'

/** @type {import("./types").default} */
const Slider = ({ className, variant = 'horizontal' }) => {
  const { listing } = useListingDetailContext()

  return (
    <div className={clsx('ScreenshotsWrapper', classes.root, className)}>
      {listing.screenshots.length > 0 && (
        <Screenshots
          screenshots={listing.screenshots.concat(listing.videos)}
          variant={variant}
          forceMainImage
          forceArrows
        />
      )}
    </div>
  )
}
export default Slider
